import {APP_NAME} from '../../../constants/constants'

const localStorage = window.localStorage

export const localStorageAMO = JSON.parse(localStorage.getItem(APP_NAME))
